import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding-top: 100px;
  justify-content: center;
  align-items: center;
  text-align: center;

  font-family: 'Source Sans Pro', sans-serif;

  & > div {
    margin-bottom: 3em;
  }
`
